import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { Popover, PopoverModule } from 'primeng/popover';
import { FromToCalendarComponent } from '../from-to-calendar/from-to-calendar.component';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';

@Component({
    selector: 'filter-by-dates-and-order',
    templateUrl: './filter-by-dates-and-order.component.html',
    imports: [SpanTooltipComponent, NgClass, PopoverModule, FromToCalendarComponent]
})
export class FilterByDatesAndOrderComponent implements OnChanges {

  filterByDates: any = {
    id: this.commonUtilsService.createId(),
  }
  private _resetDates: boolean = false;

  @Input() item: any;
  @Input() filterOrder: string | any;
  @Input() order: boolean = false;
  @Input() dateFilter: boolean = false;
  @Input() typeOverlay: string = 'overlay';
  @Output() resetDatesChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() launchActionFilterOrderEmit = new EventEmitter();
  @ViewChild(Popover) dropdown: Popover;
  @ViewChild('filterByDatesAndOrder') filterByDatesAndOrder: ElementRef;
  @Input()
  set resetDates(value: boolean) {
    const prev = this._resetDates;
    this._resetDates = value;
    if (prev === true && value === false) {
      this.resetDatesChange.emit(false);
    }
  }
  get resetDates(): boolean {
    return this._resetDates;
  }

  constructor(
    private dropdownsOpenFactory: DropdownsOpenFactory,
    private commonUtilsService: CommonUtilsService
  ) { }

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.dropdown);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item']) {
      this.filterByDates.label = this.item.name;
    }
    if (changes['resetDates'] && changes['resetDates'].currentValue) {
      console.log('entra aqui', changes['resetDates']);
      this.resetDatesChange.emit(false);
    }
  }

  orderColumn() {
    this.launchActionFilterOrderEmit.emit({ newValue: this.item.filterOrder, action: 'order' });
  }

  toggleFilter(e: any) {
    this.commonUtilsService.toggleFilterOverlay(e, this.dropdown, this.typeOverlay, this.filterByDatesAndOrder.nativeElement);
  }

  onChangeCalendar(e: any) {
    this.launchActionFilterOrderEmit.emit({ newValue: e.dates, action: 'calendar' });
    this.dropdownsOpenFactory.closeDropdown();
  }
}
